export default __webpack_public_path__ + "static/media/SSP.9dbc3714.svg";